import { usePage } from "@inertiajs/react"
import type { ReactNode } from "react"

import { Navbar } from "@/components/navbar"

export function AppShell({ children }: { children: ReactNode }) {
  const { auth } = usePage().props

  return (
    <>
      {auth.user && <Navbar user={auth.user} />}
      {children}
    </>
  )
}
